import { WidgetTenantControlChangesPeriods } from 'models/dto/widgets/widget71DTO';
import { createColorGradient } from './color';
import { enumCount } from './object';

export const getControlChangesPeriodGradient = (): string[] => {
  const startColor = '#44e359';
  const endColor = '#445ce3';
  const colors = createColorGradient(startColor, endColor, enumCount(WidgetTenantControlChangesPeriods));

  return colors;
};
